"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.onbalanceSearchUri = exports.onvioSearchUri = exports.onbalanceBrowseSubjectsUri = exports.onvioBrowseSubjectsUri = exports.helpServicesUri = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var helpServicesUri = '/v1/query/';
exports.helpServicesUri = helpServicesUri;

var onvioBrowseSubjectsUri = function onvioBrowseSubjectsUri(country, lang, userType) {
  var _context, _context2, _context3;

  return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "/ua/help/".concat(country, "-")).call(_context3, lang, "/")).call(_context2, userType, "/core/browse-subjects-")).call(_context, userType, ".htm");
};

exports.onvioBrowseSubjectsUri = onvioBrowseSubjectsUri;

var onbalanceBrowseSubjectsUri = function onbalanceBrowseSubjectsUri(country, lang) {
  var _context4;

  return (0, _concat.default)(_context4 = "/ua/smb/".concat(country, "-")).call(_context4, lang, "/admin/setup/browse-subjects.htm");
};

exports.onbalanceBrowseSubjectsUri = onbalanceBrowseSubjectsUri;

var onvioSearchUri = function onvioSearchUri(country, lang, userType) {
  var _context5, _context6;

  return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "/ua/help/search/".concat(country, "-")).call(_context6, lang, "/")).call(_context5, userType, "/results.htm");
};

exports.onvioSearchUri = onvioSearchUri;

var onbalanceSearchUri = function onbalanceSearchUri(country, lang) {
  var _context7;

  return (0, _concat.default)(_context7 = "/ua/smb/search/".concat(country, "-")).call(_context7, lang, "/admin/results.htm");
};

exports.onbalanceSearchUri = onbalanceSearchUri;
